import React, { useEffect, useState, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { getStateSlice } from "../../../store/slices/state";
import { getAllStockSlice } from "../../../store/slices/stockInventorySlice";
import {
  createPharmaSettlementSlice,
  updatePharmaSettlementSlice,
  getAllPharmaSettlementSlice,
  getPharmaSettlementByIdSlice,
  resetUpdatePharmaSettlementMessage,
  resetAddPharmaSettlementMessage,
} from "../../../store/slices/pharmaSettlementSlice";
import Table from "../../common/Table/table";
import { useNavigate } from "react-router-dom";
import AddUpdatePharmaSettlement from "./addUpdatePharmaSettlement";

const PharmaSettlement = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [reportFromData, setReportFromData] = useState({
    fromDate: "",
    toDate: "",
  });
  const [viewModal, setViewModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const initialState = {
    supplierName: "",
    supplierId: "",
    settlementDate: "",
    settlementId: "",
    settledBy: "",
    placeOfSupply: "",
    placeOfSupplyName: "",
    items: [],
    totalAmount: "",
    discount: "",
    discountPercent: "",
    subTotal: "",
    medicineRows: [],
    settlementStatus: "Pending",
    settlementReason: "Expired",
  };

  const [settlementFormData, setSettlementFormData] = useState(initialState);

  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { userInfo, token } = useSelector((state) => state.auth);
  const { settlementStatus } = useSelector((state) => state.tablePaidStatus);
  const clinicId =clinicInfo?.[0]?.clinicId ||null;
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getStateSlice({ token }));
    dispatch(
      getAllStockSlice({
        clinicId,
        token,
      }),
    );
  }, [dispatch, token, clinicId, showModal, setShowModal]);

  const { state } = useSelector((state) => state.state);
  const { stockInventory } = useSelector((state) => state.stockInventory);
  const {
    pharmaSettlement,
    createPharmaSettlementSuccessMessage,
    createPharmaSettlementErrorMessage,
    updatePharmaSettlementSuccessMessage,
    updatePharmaSettlementErrorMessage,
    searchPharmaSettlementErrorMessage,
    totalCount,
    totalPages,
    currentPage,
    isLoading,
  } = useSelector((state) => state.PharmaSettlement);

  const [inputError, setInputError] = useState({
    supplier: false,
    settlementId: false,
    settlementDate: false,
  });

  const fetchPharmaSettlement = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getAllPharmaSettlementSlice({
            clinicId,
            token,
            settlementStatus,
            currentPage: page,
            limit: lim,
            search: search || undefined,
            fromDate: reportFromData.fromDate || undefined,
            toDate: reportFromData.toDate || undefined,
          }),
        );
      }
    },
    [
      dispatch,
      clinicId,
      token,
      settlementStatus,
      pageLimit,
      searchValue,
      reportFromData.fromDate,
      reportFromData.toDate,
    ],
  );

  useEffect(() => {
    if (clinicId && token) {
      fetchPharmaSettlement(1, pageLimit, searchValue);
    }
  }, [
    clinicInfo,
    token,
    settlementStatus,
    pageLimit,
    searchValue,
    fetchPharmaSettlement,
  ]);
  const handlePageChange = (page) => {
    fetchPharmaSettlement(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchPharmaSettlement(1, newLimit, searchValue);
  };

  useEffect(() => {
    showTostifyMessageAndReset(
      createPharmaSettlementSuccessMessage,
      showToastifySuccess,
      resetAddPharmaSettlementMessage,
    );
    showTostifyMessageAndReset(
      createPharmaSettlementErrorMessage,
      showToastifyError,
      resetAddPharmaSettlementMessage,
    );
    showTostifyMessageAndReset(
      updatePharmaSettlementSuccessMessage,
      showToastifySuccess,
      resetUpdatePharmaSettlementMessage,
    );
    showTostifyMessageAndReset(
      updatePharmaSettlementErrorMessage,
      showToastifyError,
      resetUpdatePharmaSettlementMessage,
    );
  }, [
    createPharmaSettlementSuccessMessage,
    createPharmaSettlementErrorMessage,
    updatePharmaSettlementSuccessMessage,
    updatePharmaSettlementErrorMessage,
    showTostifyMessageAndReset,
  ]);

  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  const handleSelectChange = (selectedOption, name) => {
    if (name === "supplier") {
      setSettlementFormData({
        ...settlementFormData,
        supplierId: selectedOption?.value,
        supplierName: selectedOption?.label,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettlementFormData((prev) => ({
      ...prev,
      [name]: value,
      items: prev.items || [],
    }));
  };

  const handlePlaceChange = (selectedOption, name) => {
    setSettlementFormData({
      ...settlementFormData,
      placeOfSupply: selectedOption?.value,
      placeOfSupplyName: selectedOption?.label,
    });
  };

  const setSettlementStatus = (value) => {
    setSettlementFormData((prev) => ({
      ...prev,
      items: prev.items ?? [],
      settlementStatus: value,
    }));
  };
  const setSettlementReason = (value) => {
    setSettlementFormData((prev) => ({
      ...prev,
      items: prev.items ?? [],
      settlementReason: value,
    }));
  };

  const handleModal = (action, settlement = null) => {
    if (action === "edit" || (action === "refund" && settlement)) {
      setSettlementFormData({
        id: settlement?._id,
        supplierId: settlement?.supplier?._id,
        supplierName: settlement?.supplier?.name,
        settlementId: settlement?.settlementId,
        settlementDate: settlement?.settlementDate?.split("T")[0],
        placeOfSupply: settlement?.placeOfSupply?._id,
        placeOfSupplyName: settlement?.placeOfSupply?.name,
        subTotal: settlement?.subTotal,
        items: settlement?.item || [],
        settlementStatus: settlement?.settlementStatus,
        settlementReason: settlement?.settlementReason,
      });
    } else if (action === "create") {
      setSettlementFormData({ ...initialState });
    }
    setShowModal(true);
    setModalAction(action);
  };
  const handleAddUpdate = async ({ medicineRows }) => {
    const subTotal = medicineRows.reduce(
      (sum, item) => sum + Number(item?.total || 0),
      0,
    );

    const settlementPayload = {
      ...settlementFormData,
      item: medicineRows,
      subTotal,
      clinicId,
      token,
      createdBy: userInfo?._id,
      settledBy: userInfo?._id,
      settlementDate:
        settlementFormData?.settlementStatus === "Settled"
          ? formattedDate
          : null,
    };
    let response;
    if (modalAction === "edit" && settlementPayload?.settlementId) {
      response = await dispatch(
        updatePharmaSettlementSlice({
          id: settlementPayload?.id,
          settlementStatus: settlementFormData?.settlementStatus,
          settlementReason: settlementFormData?.settlementReason,
          clinicId,
          token: token,
          settlementDate:
            settlementFormData?.settlementStatus === "Settled" && formattedDate,
          settledBy:
            settlementFormData?.settlementStatus === "Settled"
              ? userInfo?._id
              : null,
          updatedBy: userInfo?._id,
        }),
      );
    } else {
      response = await dispatch(createPharmaSettlementSlice(settlementPayload));
    }
    if (response?.payload?.success) {
      dispatch(
        getAllPharmaSettlementSlice({
          clinicId,
          token,
          settlementStatus: settlementStatus,
        }),
      );
      setSettlementFormData(initialState);
      setShowModal(false);
    }
  };
  const tableHead = [
    { title: "Supplier Name", key: "supplierName" },
    { title: "Settlement Date", key: "settlementDate" },
    { title: "Amount", key: "amount" },
    { title: "Status", key: "status" },
  ];

  const handleEdit = async (settlement) => {
    try {
      const res = await dispatch(
        getPharmaSettlementByIdSlice({ id: settlement?.id, token }),
      );
      const settlementData = res?.payload?.result?.list;
      setSettlementFormData({
        id: settlementData?._id,
        supplierId: settlementData?.supplier?._id,
        supplierName: settlementData?.supplier?.name,
        settlementDate: settlementData?.settlementDate?.split("T")[0],
        placeOfSupply: settlementData?.placeOfSupply?._id,
        placeOfSupplyName: settlementData?.placeOfSupply?.name,
        subTotal: settlementData?.subTotal,
        items: settlementData?.item || [],
        settlementStatus: settlementData?.settlementStatus,
        settlementReason: settlementData?.settlementReason,
      });
      handleModal("edit", settlementData);
    } catch (error) {
      console.error("Failed to get Settlement Data: Please Try Later..", error);
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    fetchPharmaSettlement(1, pageLimit, value);
  };

  const handleFilter = async () => {
    fetchPharmaSettlement(1, pageLimit, searchValue);
  };

  const handleClear = useCallback(() => {
    setReportFromData({ fromDate: "", toDate: "" });
    fetchPharmaSettlement(1, pageLimit, searchValue);
  }, [fetchPharmaSettlement, pageLimit, searchValue]);

  return (
    <>
      <div className="row">
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 mt-2">
          <button className="btn btn-primary mt-3" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>
      <>
        <div className="container mt-4">
          <Table
            tableHead={tableHead}
            tableBody={
              pharmaSettlement &&
              pharmaSettlement?.map((item) => ({
                id: item?._id,
                supplierName: item?.supplier?.name || "N/A",
                settlementDate: item?.settlementDate?.split("T")[0] || "N/A",
                amount: item?.subTotal?.toFixed(2) || "N/A",
                status: item?.settlementStatus || "N/A",
              }))
            }
            handleAddBtn={true}
            handleSearchOption={true}
            searchValue={searchValue}
            handleSearch={handleSearch}
            errorMessage={searchPharmaSettlementErrorMessage}
            handleEdit={handleEdit}
            addModal={() => handleModal("create")}
            handleShare={false}
            showPaymentStatusTab={false}
            hideStatusTab={true}
            payemntHeaderColor="paymentTabcolor"
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            limit={pageLimit}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            showPagination={true}
            showLimitDropdown={true}
            isLoading={isLoading}
          />

          <AddUpdatePharmaSettlement
            showModal={showModal}
            setShowModal={setShowModal}
            handleAddUpdate={handleAddUpdate}
            settlementFormData={settlementFormData}
            setSettlementFormData={setSettlementFormData}
            handleSelectChange={handleSelectChange}
            handlePlaceChange={handlePlaceChange}
            modalAction={modalAction}
            setInputError={setInputError}
            state={state}
            medicines={stockInventory}
            setSettlementStatus={setSettlementStatus}
            handleChange={handleChange}
            setSettlementReason={setSettlementReason}
          />
          <Modal
            centered
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Are You Sure Want to Cancel it?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              After Cancellation, you won't be able to recover the data
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => setDeleteModal(false)}
                className="p-2"
              >
                Back to Page
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    </>
  );
};

export default PharmaSettlement;
